// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"926f399a","533":"40a68c05"}[chunkId] + ".chunk.js";
};